import styled from "styled-components";

import { EmployerContent } from "./components/EmployerContent";
import { SelectContent } from "./components/SelectContent";

export function EmployerPage() {
  return (
    <Container>
      <SelectContent />
      <EmployerContent />
    </Container>
  );
}

const Container = styled.div``;
